<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between border-b pb-3">
      <h2 class="text-xl font-semibold tracking-tight">Recent Projects</h2>
      <a href="/projects" class="text-sm font-medium hover:underline text-muted-foreground">View All &rarr;</a>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Card 
        v-for="project in displayedProjects" 
        :key="project.title"
        class="cursor-pointer transition-colors hover:bg-muted/50"
        @click="openProject(project.demo)"
      >
        <template #header>
          <div class="flex justify-between items-start">
            <h3 class="font-bold leading-none">{{ project.title }}</h3>
          </div>
        </template>
        <p class="text-sm text-muted-foreground mb-4">
          {{ project.description }}
        </p>
        <div v-if="project.domain" class="text-xs font-mono text-muted-foreground flex items-center">
          <font-awesome-icon icon="external-link-alt" class="mr-2 h-3 w-3" />
          {{ project.domain }}
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from './ui/Card.vue';

export default {
  name: "ProjectsSection",
  components: {
    Card
  },
  data() {
    return {
      projects: [
        {
          title: "Placehub Rental System",
          description: "A comprehensive apartment rental platform with user authentication, apartment management, and rental agreement features.",
          domain: "placehub.bsit3a2025.com",
          demo: "https://placehub.bsit3a2025.com",
        },
        {
          title: "Bantay Panahon",
          description: "A comprehensive Filipino weather application providing reliable and easy-to-understand weather information.",
          domain: "bantaypanahon.vercel.app",
          demo: "https://bantaypanahon.vercel.app",
        },
        {
          title: "Procurease (Procurement Management System)",
          description: "A full-stack procurement management system designed to modernize and centralize institutional purchasing and financial workflows.",
          domain: "procurease.bsit3a2025.com",
          demo: "https://procurease.bsit3a2025.com/",
        },
        {
          title: "OCR Receipt",
          description: "A web-based platform designed to streamline the management of reimbursements, billing, and receipt processing for employees, HR, and administrators.",
        },
      ],
    };
  },
  computed: {
    displayedProjects() {
      return this.projects;
    },
  },
  methods: {
    openProject(url) {
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  },
};
</script>
